// Centralized cache utilities for dashboard data
// Keeps cache consistent across pages and auth events
import { API, apiRequest } from './api';

const CACHE_TTL_MS = 5 * 60 * 1000; // 5 minutes
let DASHBOARD_CACHE = null; // { data: { user, purchases, surveys }, ts }

export function getDashboardCache() {
  if (!DASHBOARD_CACHE) return null;
  if (Date.now() - DASHBOARD_CACHE.ts > CACHE_TTL_MS) return null;
  return DASHBOARD_CACHE.data;
}

export function setDashboardCache(data) {
  DASHBOARD_CACHE = { data, ts: Date.now() };
}

export function clearDashboardCache() {
  DASHBOARD_CACHE = null;
}

// Refreshes dashboard cache by fetching latest user, purchases, and surveys
export async function refreshDashboardCache(token) {
  if (!token) return null;
  try {
    const [userRes, purchasesRes, surveysRes] = await Promise.all([
      apiRequest(API.USERS_ME, { token }).then((r) => r.json()),
      apiRequest(API.MY_PURCHASES, { token }).then((r) => r.json()),
      apiRequest(API.MY_SURVEY_RESULTS, { token }).then((r) => r.json()),
    ]);
    const payload = {
      user: userRes,
      purchases: purchasesRes || [],
      surveys: surveysRes || [],
    };
    setDashboardCache(payload);
    return payload;
  } catch (e) {
    // Do not throw during auth lifecycle; leave cache empty on failure
    clearDashboardCache();
    return null;
  }
}
